import { FullPageModule } from '../../../styles/global.styles';
import {
  CoverContainer,
  ImageContainer,
  TitleContainer,
  Typology,
  Address,
  OperationChip,
} from './cover.styles';
import { useIntl } from 'react-intl';
import ResidentialCover from '../../../assets/images/covers/Image_Residencial.png';
import GarageCover from '../../../assets/images/covers/Image_garage.png';
import LandCover from '../../../assets/images/covers/Image_land.png';
import PremiseCover from '../../../assets/images/covers/Image_local.png';
import OfficeCover from '../../../assets/images/covers/Image_office.png';
import StorageCover from '../../../assets/images/covers/Image_storage.png';
import WarehouseCover from '../../../assets/images/covers/Image_warehouses.png';
import BuildingCover from '../../../assets/images/covers/Image_Building.png';
import { ReportDataResponse } from '../../../types/reportData.interface';
export const ReportCover = ({
  reportData,
  listingType,
  operation,
  address,
}: {
  reportData: ReportDataResponse;
  listingType: number;
  operation: number;
  address: string;
}) => {
  const intl = useIntl();
  return (
    <FullPageModule>
      <CoverContainer>
        <ImageContainer>
          {reportData.logo && (
            <img
              src={reportData.logo}
              style={{
                width: 'auto',
                maxWidth: '40%',
                height: '20%',
                objectFit: 'contain',
                display: 'block',
                margin: '0 auto',
              }}
              crossOrigin="anonymous"
            />
          )}
          <img
            src={
              AssetReportCoverImageDictionary[
                listingType as keyof typeof AssetReportCoverImageDictionary
              ]
            }
            style={{
              height: '70%',
            }}
          />
        </ImageContainer>
        <TitleContainer>
          <Typology color={operation === 1 ? '#0077b6' : '#CC7D34'}>
            {intl.formatMessage({ id: `listingTypes.${listingType}` })}
          </Typology>
          <Address>
            {address.length > 67 ? `${address.slice(0, 67)}...` : address}
          </Address>
          <OperationChip $isSale={operation === 1}>
            {intl.formatMessage({ id: `operation.${operation}` })}
          </OperationChip>
        </TitleContainer>
      </CoverContainer>
    </FullPageModule>
  );
};

const AssetReportCoverImageDictionary = {
  1: ResidentialCover,
  2: OfficeCover,
  5: PremiseCover,
  6: WarehouseCover,
  7: GarageCover,
  8: LandCover,
  11: StorageCover,
  12: BuildingCover,
};
